import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ToggleButtons, GloveLocation } from 'yankees-react-utils';

const VIEW = { ALL: 'all', LHH: 'lhh', RHH: 'rhh' };

const StyledContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 700px;
`;

const buildSeries = (translate, data, islhb) => {
    const percentage = (value) => Math.floor((value) * 100);
    const filteredData = data.filter((d) => d.islhb === islhb);

    const gsOffData = filteredData.find((d) => d.loc === -3);
    const gsEdgeData = filteredData.find((d) => d.loc === -2);
    const gsPlateData = filteredData.find((d) => d.loc === -1);
    const asPlateData = filteredData.find((d) => d.loc === 1);
    const asEdgeData = filteredData.find((d) => d.loc === 2);
    const asOffData = filteredData.find((d) => d.loc === 3);

    const playerData = {
        name: translate('baseball.player'),
        data: [
            percentage(gsOffData.player),
            percentage(gsEdgeData.player),
            percentage(gsPlateData.player),
            percentage(asPlateData.player),
            percentage(asEdgeData.player),
            percentage(asOffData.player),
        ],
    };

    const leagueData = {
        name: translate('baseball.league'),
        data: [
            percentage(gsOffData.league),
            percentage(gsEdgeData.league),
            percentage(gsPlateData.league),
            percentage(asPlateData.league),
            percentage(asEdgeData.league),
            percentage(asOffData.league),
        ],
    };

    return [playerData, leagueData];
};

const ReceivingGloveLocations = ({ gloveLocationsData }) => {
    const { t: translate } = useTranslation();
    const [view, setView] = useState(VIEW.ALL);
    const options = [
        { name: translate('common.all'), value: VIEW.ALL, variant: 'default' },
        { name: translate('baseball.lhh'), value: VIEW.LHH, variant: 'default' },
        { name: translate('baseball.rhh'), value: VIEW.RHH, variant: 'default' },
    ];

    if (gloveLocationsData.length === 0) {
        return (
            <div>
                <h4>{translate('sections.reports.catcher.receiving.glove-locations')}</h4>
                {translate('sections.reports.catcher.receiving.no-glove-data')}
            </div>
        );
    }

    const categories = [translate('sections.reports.catcher.receiving.gloveside-off-plate'), translate('sections.reports.catcher.receiving.gloveside-edge'), translate('sections.reports.catcher.receiving.gloveside-plate'), translate('sections.reports.catcher.receiving.armside-plate'), translate('sections.reports.catcher.receiving.armside-edge'), translate('sections.reports.catcher.receiving.armside-off-plate')];
    let title = '';
    let seriesData = [];

    if (view === VIEW.ALL) {
        title = translate('sections.reports.catcher.receiving.glove-locations');
        seriesData = buildSeries(translate, gloveLocationsData, null);
    } else if (view === VIEW.LHH) {
        title = `${translate('sections.reports.catcher.receiving.glove-locations')} ${translate('baseball.abbr-versus')} ${translate('baseball.lhh')}`;
        seriesData = buildSeries(translate, gloveLocationsData, 1);
    } else if (view === VIEW.RHH) {
        title = `${translate('sections.reports.catcher.receiving.glove-locations')} ${translate('baseball.abbr-versus')} ${translate('baseball.rhh')}`;
        seriesData = buildSeries(translate, gloveLocationsData, 0);
    }

    return (
        <StyledContainer>
            <ToggleButtons name="receivingglove" size="sm" options={options} onChange={(value) => setView(value)} defaultValue={VIEW.ALL} />
            <GloveLocation seriesData={seriesData} categories={categories} title={title} titleX={translate('sections.reports.catcher.receiving.pct-of-pitches')} titleY={translate('sections.reports.catcher.receiving.horizontal-glove')} tooltipSuffix="%" />
        </StyledContainer>
    );
};

ReceivingGloveLocations.propTypes = {
    gloveLocationsData: PropTypes.arrayOf(PropTypes.shape({
        loc: PropTypes.number,
        islhb: PropTypes.number,
        league: PropTypes.number,
        player: PropTypes.number,
    })).isRequired,
};

export default ReceivingGloveLocations;
